import 'react';

export interface Tour {
  id: string;
  slug: string;
  title: string;
  subtitle: string;
  description: string;
  price: number;
  priceUnit: string;
  originalPrice?: number;
  duration: string;
  difficulty: string;
  tags: string[];
  imageUrl: string;
  nextDate?: string;
  status?: string;
  imagesCount: number;
  limitedSpots?: boolean;
  categoryId?: number;
  gallery?: string[];
  flashDeal?: {
    originalPrice: number;
    dealPrice: number;
    postOfferPrice?: number;
    /** Offer set in the admin: ends at this moment for everyone (ISO). Without it, each visit gets a short timer. */
    endsAt?: string;
  };
}

export const tours: Tour[] = [
  {
    id: '2',
    slug: 'Passeio-em-aquamarina-ll',
    title: 'Roteiro sul a Bordo da Escuna Aquamarina II- Paraty,rj',
    subtitle: 'Escuna Aquamarina Il 100% nova – Um Dia de Encantos pelas Águas de Paraty',
    description: 'Explore as deslumbrantes praias de Paraty a bordo da nova escuna Aquamarina II, em um passeio inesquecível repleto de aventura e conforto!',
    price: 115,
    priceUnit: 'Adulto',
    originalPrice: 150,
    duration: 'aprox. O dia todo',
    difficulty: 'Fácil',
    tags: ['Fácil', 'Aventura', 'Com guia', 'De barco', 'Dia inteiro', 'Pet-friendly'],
    imageUrl: 'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/55e971c5-66d3-4481-cd46-77b181f81500/w=900',
    nextDate: '24/05/2026',
    status: 'Vagas Limitadas',
    imagesCount: 21,
    limitedSpots: true,
    flashDeal: { originalPrice: 130, dealPrice: 110, postOfferPrice: 115 },
  },
  {
    id: '3',
    slug: 'jeep-mata-atlantica',
    title: 'Explore Paraty de Jeep em uma Aventura pela Mata Atlântica',
    subtitle: '',
    description: 'Explore Paraty em um emocionante passeio de jeep 4x4 Cachoeiras, alambique, casa da farinha, queijara, poço de tarzan, estrada Real & Sabores de Paraty',
    price: 140,
    priceUnit: 'Adulto',
    originalPrice: 120,
    duration: 'aprox. O dia todo',
    difficulty: 'Fácil',
    tags: ['Fácil', 'Aventura', 'Natureza'],
    imageUrl: 'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/488d8c1d-de54-44ca-dc3b-e4c649fb2a00/w=900',
    nextDate: '23/05/2026',
    status: 'Vagas Limitadas',
    imagesCount: 15,
    limitedSpots: true,
    flashDeal: { originalPrice: 155, dealPrice: 130, postOfferPrice: 130 },
  },
  {
    id: '4',
    slug: 'jeep-mata-atlantica-15823',
    title: 'Descubra as praias caiçaras de Trindade-RJ🌴🌊',
    subtitle: 'O melhor de Trindade em um dia!',
    description: 'Explore Paraty em um emocionante passeio pra Trindade, com degustações de queijos, e aventuras em cachoeiras e praias',
    price: 170,
    priceUnit: 'ADULTO',
    originalPrice: 200,
    duration: 'aprox. 5:30 horas',
    difficulty: 'Fácil',
    tags: ['Fácil', 'Adrenalina', 'Autoguiado', 'Aventura', 'Cultural', 'De barco', 'Histórico'],
    imageUrl: 'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/c714424a-0aa8-4049-9095-0c8281e5c200/w=900',
    nextDate: '23/05/2026',
    status: 'Vagas Limitadas',
    imagesCount: 1,
    limitedSpots: true,
    flashDeal: { originalPrice: 190, dealPrice: 155, postOfferPrice: 160 },
  },
  {
    id: '5',
    slug: 'saco-de-mamangua-lancha-rapida',
    title: 'Passeio de Lancha pelo Saco do Mamanguá',
    subtitle: '',
    description: 'Explore o deslumbrante fiorde tropical do Brasil em um emocionante passeio de lancha rápida saindo de Paraty, mergulhando em águas cristalinas e admirando a exuberante Mata Atlântica!',
    price: 250,
    priceUnit: 'pessoa',
    originalPrice: 300,
    duration: 'aprox. O dia todo',
    difficulty: 'Intermediário',
    tags: ['Intermediário', 'A pé', 'Adrenalina', 'Ambiente familiar', 'Aventura', 'Com guia', 'De barco', 'Dia inteiro', 'Fast-track', 'Natureza'],
    imageUrl: 'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/2f279564-6d0a-48a3-22c9-037d7309ec00/w=900',
    nextDate: '24/05/2026',
    status: 'Vagas Limitadas',
    imagesCount: 24,
    limitedSpots: true,
    flashDeal: { originalPrice: 280, dealPrice: 230, postOfferPrice: 250 },
  },
  {
    id: '6',
    slug: 'mergulho',
    title: 'Mergulho em Paraty: Aventura Subaquática Inesquecível',
    subtitle: '',
    description: 'Explore as maravilhas subaquáticas de Paraty com um mergulho inesquecível em águas cristalinas, cercado por uma rica biodiversidade marinha!',
    price: 490,
    priceUnit: 'pessoa',
    originalPrice: 300,
    duration: 'aprox. 5 horas',
    difficulty: 'Intermediário',
    tags: ['Intermediário'],
    imageUrl: 'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/322496a5-351d-4f61-341b-c92a02c98200/w=900',
    imagesCount: 8,
    status: 'Vagas Limitadas',
    limitedSpots: true,
  },
  {
    id: '7',
    slug: 'experiencia-privativa-nascer-do-sol-na-pedra-da-marcela',
    title: 'Nascer do Sol na Pedra da Marcela, Paraty: Passeio Privativo',
    subtitle: '',
    description: 'Descubra a magia de Paraty com um passeio exclusivo para ver o nascer do sol na Pedra da Marcela, personalizado para você!',
    price: 600,
    priceUnit: 'Grupo',
    originalPrice: 750,
    duration: 'aprox. 6 horas',
    difficulty: 'Intermediário',
    tags: ['Intermediário', 'A partir de 13 anos', 'Aventura', 'Com guia', 'Esportes', 'Natureza', 'Para adultos'],
    imageUrl: 'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/83cebe36-ef1f-4a3b-e01b-e1340522f700/w=900',
    nextDate: '24/05/2026',
    status: 'Vagas Limitadas',
    imagesCount: 3,
    limitedSpots: true,
  },
  {
    id: '8',
    slug: 'passeio-de-lancha-privativa-na-baia-de-paraty-20262',
    title: 'Passeio de Lancha Privativa na Baía de Paraty- LANCHA BABI',
    subtitle: '8 pessoas e 1',
    description: 'Desfrute de um passeio de lancha privativa na Baía de Paraty, explorando águas cristalinas e ilhas paradisíacas com roteiros personalizados para uma experiência inesquecível!',
    price: 1300,
    priceUnit: 'casal',
    originalPrice: 1600,
    duration: 'aprox. O dia todo',
    difficulty: 'Fácil',
    tags: ['Fácil', 'Ambiente familiar', 'Aventura', 'Com guia', 'De barco', 'Ideal para casais', 'Ideal para crianças', 'Ideal para famílias', 'Praia', 'Privativo', 'Romântico'],
    imageUrl: 'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/4b01080d-a61a-4c3d-a1cd-f912b1b48c00/w=900',
    status: 'Privativo ate 9 pessoas',
    imagesCount: 5,
  },
  {
    id: '9',
    slug: 'lancha-privativa-em-paraty-calobe',
    title: 'Passeio de Lancha Privativa na Baía de Paraty- lancha Calm Sea',
    subtitle: 'ate 6 pessoas',
    description: 'Desfrute de um passeio de lancha privativa na Baía de Paraty, explorando águas cristalinas e ilhas paradisíacas com roteiros personalizados para uma experiência inesquecível!',
    price: 1500,
    priceUnit: 'casal',
    originalPrice: 1600,
    duration: 'aprox. 5 horas',
    difficulty: 'Fácil',
    tags: ['Fácil', 'Ambiente familiar', 'Aventura', 'Com guia', 'De barco', 'Ideal para casais', 'Ideal para crianças', 'Ideal para famílias', 'Praia', 'Privativo', 'Romântico'],
    imageUrl: 'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/23667852-e5c2-4da8-1e4e-c3587d7eec00/w=900',
    status: 'Privativo',
    imagesCount: 4,
  },
  {
    id: '10',
    slug: 'passeio-de-lancha-privativa-na-baia-de-paraty-lancha-babi-20263',
    title: 'Passeio de Lancha Privativa na Baía de Paraty- LANCHA CABOLE',
    subtitle: 'ate 9 pessoas',
    description: 'Desfrute de um passeio de lancha privativa na Baía de Paraty, explorando águas cristalinas e ilhas paradisíacas com roteiros personalizados para uma experiência inesquecível!',
    price: 1450,
    priceUnit: 'casal',
    originalPrice: 1600,
    duration: 'aprox. 5 horas',
    difficulty: 'Fácil',
    tags: ['Fácil', 'Ambiente familiar', 'Aventura', 'Com guia', 'De barco', 'Ideal para casais', 'Ideal para crianças', 'Ideal para famílias', 'Praia', 'Privativo', 'Romântico'],
    imageUrl: 'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/7662061c-665b-44cb-c42b-9f1dbca09900/w=900',
    status: 'Privativo',
    imagesCount: 5,
  },
  {
    id: '11',
    slug: 'experiencia-privativa-em-paraty-a-bordo-de-uma-escuna-de-luxo',
    title: 'Escuna completa somente pra sua familia Luxo Privativo em Paraty',
    subtitle: 'ideal pra casal e pasar noite e amanhecer no alto mar',
    description: 'Desfrute de um passeio privativo e luxuoso em uma escuna por Paraty, explorando praias paradisíacas com conforto e personalização total!',
    price: 4000,
    priceUnit: 'Escuna privada',
    originalPrice: 8000,
    duration: '',
    difficulty: '',
    tags: ['Ambiente familiar', 'De barco', 'Ideal para famílias', 'Pernoite', 'Praia', 'Privativo'],
    imageUrl: 'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/3c20c61c-3666-40f4-0ddd-4013fca5f800/w=900',
    nextDate: '24/05/2026',
    status: 'Privativo',
    imagesCount: 8,
  },
  {
    id: '12',
    slug: 'privativo-lirio-dos-vales',
    title: 'Passeio Privativo de Lancha em Paraty - lirios dos vales',
    subtitle: '',
    description: 'Explore as maravilhas de Paraty em um passeio privativo de lancha totalmente personalizado, com conforto e exclusividade a bordo do Lirio dos Vales!',
    price: 950,
    priceUnit: 'Grupo',
    duration: '',
    difficulty: '',
    tags: ['Ambiente familiar', 'De barco'],
    imageUrl: 'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/88debfda-d4da-4e58-2c32-18156fdeca00/w=900',
    imagesCount: 3,
  },
  {
    id: '13',
    slug: 'lancha-privada-madame',
    title: 'Passeio de Lancha Privada em Paraty: MADAME',
    subtitle: 'ate 7 pessoas',
    description: 'Embarque na lancha Madame para um passeio inesquecível em Paraty, repleto de conforto, beleza e aventura personalizada!',
    price: 1300,
    priceUnit: 'Grupo',
    duration: '',
    difficulty: '',
    tags: ['Ambiente familiar', 'De barco', 'Ideal para casais', 'Ideal para crianças', 'Praia', 'Privativo', 'Romântico'],
    imageUrl: 'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/ca4ed28b-8e81-42d8-940a-bd02490d6200/w=900',
    status: 'privativo',
    imagesCount: 11,
  },
  {
    id: '14',
    slug: 'passeio-privativo-de-lancha-em-paraty-lirios-dos-vales-22435',
    title: 'Passeio Privativo em Paraty - capitão NY',
    subtitle: '',
    description: 'Explore as maravilhas de Paraty em um passeio privativo de lancha totalmente personalizado, com conforto e exclusividade a bordo do Lirio dos Vales!',
    price: 1000,
    priceUnit: 'Grupo',
    duration: '',
    difficulty: '',
    tags: ['Ambiente familiar', 'De barco'],
    imageUrl: 'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/4ea011a8-859a-4e5a-050b-4dd888e99000/w=900',
    imagesCount: 4,
  },
  {
    id: '16',
    slug: 'lancha-privada-praiana',
    title: 'Lancha Privada em Paraty; Praiana',
    subtitle: 'ate 7 pessoas',
    description: 'Descubra o paraíso com um passeio de lancha privada em Paraty, explorando praias deslumbrantes com conforto e exclusividade!',
    price: 1400,
    priceUnit: 'Grupo',
    duration: '',
    difficulty: '',
    tags: ['Ideal para famílias', 'Praia', 'Privativo'],
    imageUrl: 'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/0a6a2d73-cb11-430f-e6b1-0601ae918100/w=900',
    imagesCount: 2,
  },
  {
    id: '17',
    slug: 'lancha-privada-vida-boa',
    title: 'Passeio de Lancha Privada, Paraty-RJ; PHOENIX Vida Boa',
    subtitle: 'ate 9 pessoas',
    description: 'Descubra a beleza de Paraty a bordo da lancha privada Mahalo, explorando roteiros incríveis com conforto e exclusividade!',
    price: 1650,
    priceUnit: 'Grupo',
    duration: '',
    difficulty: '',
    tags: ['Ambiente familiar', 'Dia inteiro', 'Ideal para casais', 'Privativo'],
    imageUrl: 'https://imagedelivery.net/EafvxYlk8cSUsWEWsetEdQ/83b60127-1a1e-46d4-965a-3024538dc300/w=900',
    imagesCount: 4,
  },
];